import React from "react";



import { useParams } from "react-router-dom";
import { useGetSinglePropertyTypeQuery,useUpdatePropertyTypeMutation } from "../../../../features/master/propertytype/propertyTypeApiSlice";
import EditService from "../EditServices";


export default function Index() {
  const { id } = useParams();
  const { data, refetch } = useGetSinglePropertyTypeQuery(id);
  const [updatePropertyType , {isLoading}] = useUpdatePropertyTypeMutation();
 

  

  return (
     <EditService isLoading={isLoading}
             data={data}
             refetch={refetch}
             id={id}
             name={"propertytype"}
             title={"PropertyType"}
             updatedData={updatePropertyType}
         />
  );
}
